"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SackPercentIcon;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SackPercentIcon(props) {
  return _react["default"].createElement("svg", _extends({
    width: "24",
    height: "24"
  }, props, {
    className: "rmi rmi-sack-percent ".concat(props.className),
    viewBox: "0 0 24 24"
  }), _react["default"].createElement("path", {
    d: "M8 7L6 2l4 2 2-2 2 2 4-2-2 5H8m8 15H8c-6 0-5-4-5-4s1-7 5-9h8c4 2 5 9 5 9s1 4-5 4m-8.5-9.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S9.83 11 9 11s-1.5.67-1.5 1.5m9 6c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5.67 1.5 1.5 1.5 1.5-.67 1.5-1.5m0-6.15L15.15 11 7.5 18.65 8.87 20l7.63-7.65z"
  }));
}